import { lazy } from 'react';
import { AuthGuard, DashboardLayout } from '@nsd/fe';
import { Calculator, FileSpreadsheet, ShieldAlert, FileSearch } from 'lucide-react';
import appIcon from './images/appIcon.png';

// Platform entitlement UUIDs. These gate nav rendering inside @nsd/fe and are
// separate from the InsightQore role-name checks done inside the views; both
// must be provisioned before the module is visible to a non-admin user.
const MODULE = {
  RAW_DATA_EXPORT: 'rawDataExport-4eddbd90-3cf2-4e4d-83c1-157ea2805f22',
  CLAIM_FRAUD: 'claimFraudDashboard-fabec743-3420-4759-a1de-e00d54ca8859',
  OON_CALCULATOR: 'oONCostCalculator-1423921a-2842-486d-bab1-82f28b804455',
};

const appConfig = {
  appId: 'actuarialQore-5c5c6b80-b864-4a10-a300-3957f66bc146',
  appName: 'Actuarial',
  // @nsd/fe sorts apps DESCENDING by priority and lands the user on the first
  // one they can access, so this must stay below Sales or anyone entitled to
  // both would be redirected here instead of Sales after login.
  priority: 0,
  path: 'actuarial',
  icon: appIcon,
  guard: AuthGuard,
  layout: DashboardLayout,
  routes: [
    {
      exact: true,
      path: '',
      view: lazy(() => import('src/views/actuarial/splash-view'))
    },
    {
      exact: true,
      path: 'raw-data-export',
      view: lazy(() => import('src/views/actuarial/raw-data-export')),
      module: MODULE.RAW_DATA_EXPORT
    },
    {
      exact: true,
      path: 'fraud-dashboard',
      view: lazy(() => import('src/views/actuarial/fraud-dashboard')),
      module: MODULE.CLAIM_FRAUD
    },
    {
      exact: true,
      path: 'claim-detail',
      view: lazy(() => import('src/views/actuarial/claim-detail')),
      module: MODULE.CLAIM_FRAUD
    },
    {
      exact: true,
      path: 'oon-calculator',
      view: lazy(() => import('src/views/actuarial/oon-calculator')),
      module: MODULE.OON_CALCULATOR
    },
  ],

  navConfig: {
    navBarItems: [
      {
        subheader: 'Data Exports',
        items: [
          {
            title: 'Raw Data Export',
            href: 'raw-data-export',
            icon: FileSpreadsheet,
            module: MODULE.RAW_DATA_EXPORT
          }
        ]
      },
      {
        subheader: 'Claim Fraud',
        items: [
          {
            title: 'Fraud Dashboard',
            href: 'fraud-dashboard',
            icon: ShieldAlert,
            module: MODULE.CLAIM_FRAUD
          },
          {
            title: 'Claim Detail',
            href: 'claim-detail',
            icon: FileSearch,
            module: MODULE.CLAIM_FRAUD
          }
        ]
      },
      {
        subheader: 'Network Cost',
        items: [
          {
            title: 'OON Cost Calculator',
            href: 'oon-calculator',
            icon: Calculator,
            module: MODULE.OON_CALCULATOR
          }
        ]
      }
    ]
  }
};

export default appConfig;
